import React, { lazy } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import Button from './Button';
export const SignalsList = () => {
  const WebinarLink = ({
    children
  }: {
    children: React.ReactNode;
  }) => <a href="https://stresslessdogs.nl/mcc-gpm" className="text-green-600 hover:text-green-700 hover:underline" data-id="element-66">
      {children}
    </a>;
  const signals = [{
    id: 1,
    title: 'Oren naar achteren',
    description: 'Veel mensen vinden dit schattig. De oren plat tegen het hoofd. "Wat lief!" Maar zoals Amee uitlegt in het webinar: "Als een hond zijn oren naar achteren heeft, is dat meestal een momentje waarop ze zich even niet helemaal prettig voelt of eventjes verstoord zijn van \'wat gebeurt daar?\'" Als dit het enige signaal is en het gaat snel over, geen probleem. Maar zie je dit tegelijk met andere signalen dan kan het betekenen dat je hond gestresst is.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/a3vav4B8cAeABUHhhUP2bY/freepik__candid-photography-with-natural-textures-and-highl__32070.png'
  }, {
    id: 2,
    title: 'Oogwit zien (het "whale eye")',
    description: 'Dit is een van de meest gemiste signalen. En een van de belangrijkste. Amee legt uit: "Oogwit zien is eigenlijk altijd een signaal van stress en angst. De spieren achter de ogen komen op spanning waardoor er oogwit zichtbaar word." Maar het gaat verder. In combinatie met het oogwit zie je vaak: Vergrote pupillen (altijd een teken van angst en stress), strakke, verschrikte ogen, gespannen spieren rondom de ogen, en een strak gespannen voorhoofd.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/tQaLPBwzUt2cunDNabkPTs/Scherm%C2%ADafbeelding_2025-09-30_om_17.19.01.png'
  }, {
    id: 3,
    title: 'Tongelen (het puntje van de tong even naar buiten)',
    description: 'Dit is zo\'n klein, subtiel signaaltje dat je het makkelijk mist. Het duurt maar een fractie van een seconde. Het puntje van de tong komt even naar buiten en gaat weer terug. Eén keer? Geen probleem. Maar zoals Amee benadrukt in haar online presentatie: "Als je het heel vaak achter elkaar ziet of in combinatie met heel veel andere stress signalen, dan is er zeker wel wat aan de hand. Dan is die hond echt zwaar gestrest." Het is dus belangrijk dat baasjes hier meer over leren. <WebinarLink>Klik hier om te zien of Amee het webinar nog eens geeft deze week.</WebinarLink>',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/1XqCugY3kPg81FAAg2tSug/freepik__candid-photography-with-natural-textures-and-highl__32072.png'
  }, {
    id: 4,
    title: 'Wegleunen en gewicht verplaatsen',
    description: 'Een hond dat een beetje bukt of opzij beweegt terwijl die stil staat. Dit is misschien wel het meeste gemist signaal. Maar het valt snel op als je weet waar je op moet letten. Amee\'s uitleg: "Het wegleunen wordt hier gedaan door de honden om te vertellen: ik vind het niet fijn, ik heb meer ruimte nodig." Kijk maar eens naar de foto\'s in het webinar. Die hond die wordt geaaid van bovenaf? Hij leunt weg. Zijn gewicht gaat naar de andere kant. Fysiek probeert hij afstand te creëren. <WebinarLink>Klik hier om te zien of het webinar deze week nog wordt gegeven.</WebinarLink>',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/86RbvNe8Zmzrr5t5Vt3iPR/freepik__candid-photography-with-natural-textures-and-highl__32074.png'
  }, {
    id: 5,
    title: 'Hoofd afwenden en oogcontact doorbreken',
    description: 'Dit signaal heeft twee betekenissen. En dat maakt het lastig. Amee legt uit: "In een normale positieve situatie betekent zal een hond het hoofd afwenden om de sfeer goed te houden. Het is dan een beleefd gebaar en om te laten weten dat de bedoelingen goed zijn." Honden onderling gebruiken dit constant. Twee honden ontmoeten elkaar. De een kijkt eventjes weg. De ander ook. Het is hun manier om te zeggen: "Rustig maar, ik kom in vrede. Geen probleem hier." Maar in een negatieve situatie is dit anders. Een hond kan hiermee ook zeggen "Ik vind dit niet fijn, stop alsjeblieft", bijvoorbeeld als een hond wordt vastgepakt dan doen ze dit vaak. Helaas begrijpt het baasje dan vaak niet de betekenis.',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/7a5N37iiw3oQD6PN3VooAm/freepik__a-realistic-color-photo-of-a-dog-being-touched-or-__32075.png'
  }, {
    id: 6,
    title: 'Gapen',
    description: '"Mijn hond is moe" hoor je vaak. En ja, soms is een gapen gewoon een gaap van moeheid. Maar niet altijd. Amee\'s uitleg uit het webinar: "Gapen is een systeem van het lichaam om spanning af te vloeien. En daarnaast werkt het als communicatiemiddel voor de omgeving om te vertellen: ik heb een beetje stress van wat er nu gebeurt. Stop alsjeblieft." <WebinarLink>Tijdens het webinar waren er voorbeeld video\'s.</WebinarLink>',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/iaDSGtvKNor3gL83fV15Fm/freepik__candid-photography-with-natural-textures-and-highl__32076.png'
  }, {
    id: 7,
    title: 'De gesloten bek met strakke mondhoeken',
    description: 'Dit signaal wordt constant gemist. Amee legt het verschil uit: "Een hond die zich echt ontspannen voelt, die heeft meestal een losjes geopende onderkaak met ontspannen mondhoeken." Kijk maar eens naar je hond als hij echt relaxed in de zon op de bank ligt. Zijn bek staat meestal een beetje open. Losjes. Ontspannen. Misschien zie je zelfs een beetje tong. Maar als er spanning op staat en het oogt een beetje streng.',
    image: 'https://images.unsplash.com/photo-1568572933382-74d440642117?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
  }];
  // Function to replace webinar with linked version
  const processText = (text: string) => {
    return text.split(/(webinar)/g).map((part, index) => part.toLowerCase() === 'webinar' ? <WebinarLink key={index} data-id="element-67">{part}</WebinarLink> : part);
  };
  return <section className="w-full bg-gray-50 py-12 px-4" data-id="element-68">
      <div className="max-w-4xl mx-auto" data-id="element-69">
        <h2 className="text-2xl md:text-3xl font-bold mb-6 text-gray-800" data-id="element-70">
          De 7 signalen die je hond geeft (en die je waarschijnlijk mist)
        </h2>
        <p className="text-lg mb-8 text-gray-700" data-id="element-71">
          Amee legde deze week in een presentatie uit dat honden zeven
          belangrijke signalen geven. Deze signalen zijn voor hondentaal wat
          woorden zijn voor mensentaal. En net zoals je geen Frans verstaat
          zonder Franse woorden te kennen, versta je geen hondentaal zonder deze
          signalen te kennen. Het is dus belangrijk dat je als baasje deze
          signalen kent.
        </p>
        <p className="text-lg mb-8 text-gray-700" data-id="element-72">
          Laten we ze een voor een doornemen.
        </p>
        {signals.map(signal => <div key={signal.id} className="mb-12 bg-white rounded-lg shadow-md overflow-hidden" data-id="element-73">
            <div className="md:flex" data-id="element-74">
              <div className="md:w-1/3" data-id="element-75">
                <div className="h-64 md:h-full" data-id="element-76">
                  <img src={signal.image} alt={signal.title} className="w-full h-full object-cover transition-opacity duration-300" loading="lazy" onError={e => {
                e.currentTarget.src = 'https://uploadthingy.s3.us-west-1.amazonaws.com/tU92B1SZwZRa2ndLJFgzs2/freepik__candid-photography-with-natural-textures-and-highl__32072.png';
                e.currentTarget.alt = 'Fallback image';
              }} data-id="element-77" />
                </div>
              </div>
              <div className="md:w-2/3 p-6" data-id="element-78">
                <div className="flex items-center mb-3" data-id="element-79">
                  <div className="bg-amber-500 text-white rounded-full w-8 h-8 flex items-center justify-center mr-3 flex-shrink-0" data-id="element-80">
                    {signal.id}
                  </div>
                  <h3 className="text-xl font-bold text-gray-800" data-id="element-81">
                    {signal.title}
                  </h3>
                </div>
                <p className="text-gray-700" data-id="element-82">
                  {signal.id === 3 ? <>
                      Dit is zo'n klein, subtiel signaaltje dat je het makkelijk
                      mist. Het duurt maar een fractie van een seconde. Het
                      puntje van de tong komt even naar buiten en gaat weer
                      terug. Eén keer? Geen probleem. Maar zoals Amee benadrukt
                      in haar online presentatie: "Als je het heel vaak achter
                      elkaar ziet of in combinatie met heel veel andere stress
                      signalen, dan is er zeker wel wat aan de hand. Dan is die
                      hond echt zwaar gestrest." Het is dus belangrijk dat
                      baasjes hier meer over leren.{' '}
                      <WebinarLink data-id="element-83">
                        Klik hier om te zien of Amee het webinar nog eens geeft
                        deze week.
                      </WebinarLink>
                    </> : signal.id === 4 ? <>
                      Een hond dat een beetje bukt of opzij beweegt terwijl die
                      stil staat. Dit is misschien wel het meeste gemist
                      signaal. Maar het valt snel op als je weet waar je op moet
                      letten. Amee's uitleg: "Het wegleunen wordt hier gedaan
                      door de honden om te vertellen: ik vind het niet fijn, ik
                      heb meer ruimte nodig." Kijk maar eens naar de foto's in
                      het {processText('webinar')}. Die hond die wordt geaaid
                      van bovenaf? Hij leunt weg. Zijn gewicht gaat naar de
                      andere kant. Fysiek probeert hij afstand te creëren.{' '}
                      <WebinarLink data-id="element-84">
                        Klik hier om te zien of het webinar deze week nog wordt
                        gegeven.
                      </WebinarLink>
                    </> : signal.id === 6 ? <>
                      "Mijn hond is moe" hoor je vaak. En ja, soms is een gapen
                      gewoon een gaap van moeheid. Maar niet altijd. Amee's
                      uitleg uit het {processText('webinar')}: "Gapen is een
                      systeem van het lichaam om spanning af te vloeien. En
                      daarnaast werkt het als communicatiemiddel voor de
                      omgeving om te vertellen: ik heb een beetje stress van wat
                      er nu gebeurt. Stop alsjeblieft."{' '}
                      <WebinarLink data-id="element-85">
                        Tijdens het webinar waren er voorbeeld video's.
                      </WebinarLink>
                    </> : processText(signal.description)}
                </p>
              </div>
            </div>
          </div>)}
        <div className="mb-12 bg-white rounded-lg shadow-md overflow-hidden" data-id="element-86">
          <div className="md:flex" data-id="element-87">
            <div className="md:w-1/3" data-id="element-88">
              <div className="h-64 md:h-full" data-id="element-89">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3KsmG8kLGqM9oG9LSzQjxG/Ontwerp_zonder_titel_%2854%29.png" alt="Amee presenteert webinar over hondensignalen" className="w-full h-full object-cover transition-opacity duration-300" loading="lazy" data-id="element-90" />
              </div>
            </div>
            <div className="md:w-2/3 p-6" data-id="element-91">
              <h3 className="text-xl font-bold text-gray-800 mb-3" data-id="element-92">
                Online presentatie over hondensignalen
              </h3>
              <p className="text-gray-700 mb-6" data-id="element-93">
                Als je meer wilt leren over hondensignalen met onder andere
                video's, meer foto's en betere uitleg van Amee zelf dan raad ik
                aan <WebinarLink data-id="element-94">haar webinar te volgen</WebinarLink>. Dit is
                een online presentatie. Aanmelden is gratis en meedoen is zeer
                gemakkelijk en kan gewoon vanaf je telefoon of tablet. "Het was
                een echte eye-opener" zei een andere deelnemer. "Ik heb al meer
                dan 40 jaar honden maar ik heb geleerd om op een hele andere
                manier naar mijn honden te kijken. Bedankt Amee!" zei de
                volgende. Wees er wel snel bij want het webinar geeft ze alleen
                nog deze week.
              </p>
              <div className="mt-4" data-id="element-95">
                <a href="https://stresslessdogs.nl/mcc-gpm" className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 text-lg inline-block" data-id="element-96">
                  Bekijk webinar planning
                </a>
              </div>
            </div>
          </div>
        </div>
        <div className="bg-amber-50 border-l-4 border-amber-500 p-6 rounded-lg mb-8" data-id="element-97">
          <h3 className="text-xl font-bold mb-4 text-gray-800" data-id="element-98">
            Meerdere signalen tegelijk
          </h3>
          <p className="text-gray-700 mb-4" data-id="element-99">
            Nu komt het belangrijke deel. En dit maakt Amee heel duidelijk in
            het <WebinarLink data-id="element-100">webinar</WebinarLink>.
          </p>
          <p className="text-gray-700 mb-4" data-id="element-101">
            Eén signaal kan toeval zijn. Maar als je een signaal in combinatie
            met een van de andere signalen ziet of kort achter elkaar dan weet
            je dat je hond meer stress ervaart dan normaal. Dat kan betekenen
            dat de omgeving te druk is of hij om een andere reden spanning
            opbouwt. Als je daar dan niks aan doet kan het zijn dat je hond
            'plotseling' uitvalt, in paniek raakt, of ander gedrag laat zien.
            Dit lijkt dan onverwachts maar dat is het niet.
          </p>
        </div>
        <div className="flex justify-center" data-id="element-102">
          <a href="https://stresslessdogs.nl/mcc-gpm" className="bg-green-500 hover:bg-green-600 text-white font-bold py-3 px-6 rounded-full transition-all duration-300 text-lg inline-flex items-center" data-id="element-103">
            <span className="flex items-center" data-id="element-104">
              Bekijk de hele presentatie over honden signalen
              <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-105" />
            </span>
          </a>
        </div>
      </div>
    </section>;
};